import type { createBrowserRouter } from 'react-router-dom'

type AppRouter = ReturnType<typeof createBrowserRouter>

// Holds the app's data router so non-React code (e.g. auth-fetch) can navigate
// imperatively. A ref, not a direct export, because the router module pulls in
// every page — importing it from a low-level service would be a cycle.
let appRouter: AppRouter | null = null

export function setAppRouter(router: AppRouter): void {
  appRouter = router
}

export function getAppRouter(): AppRouter | null {
  return appRouter
}
